import { formatLeaderboardNumber } from '@/features/leaderboard/formatLeaderboardNumber'

// Leaderboard number format (12.4K, 1.24M, 2.62B); no data shows a dash.
export const formatStatValue = (value?: number | null): string =>
  value == null || value <= 0 ? '—' : formatLeaderboardNumber(value)
